"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVENTORY_FAVORITE_FIELD_OVERRIDES = exports.INVENTORY_METADATA_JSON = void 0;
exports.INVENTORY_METADATA_JSON = {
    objectCategory: 'CN=Person,CN=Schema,CN=Configuration,DC=windomain,DC=local',
    objectClass: 'top;person;organizationalPerson;user',
    objectSid: 'S-1-5-21-2232977720-3053628852-2340862552-1000',
    primaryGroupId: '513',
    sAMAccountName: 'vagrant',
    whenCreated: '4/18/2020 6:58:27 AM',
    userAccountControl: '66048',
    lastLogon: 132765275609170160,
    pwdLastSet: 132316856072608530,
    accountExpires: 0,
    distinguishedName: 'CN=vagrant,CN=Users,DC=windomain,DC=local',
    objectGUID: '{ea74b2a2-2647-4c02-8941-b801e17f6bf6}',
    cn: 'vagrant',
};
// Inventory favorite fields aren't single string keys, they're a serialization
// of a JSON path and expect to be in a particular format (stringified array of keys.)
exports.INVENTORY_FAVORITE_FIELD_OVERRIDES = {
    fieldName: JSON.stringify([`${Object.keys(exports.INVENTORY_METADATA_JSON)[0]}`]),
    fieldType: 'INVENTORY',
};
